/**
 * Tailwind color palette for muscle groups
 * Using softer, more readable colors with good contrast
 */
const MUSCLE_COLOR_PALETTE = [
	{ bg: 'bg-blue-100', text: 'text-blue-700' },
	{ bg: 'bg-purple-100', text: 'text-purple-700' },
	{ bg: 'bg-pink-100', text: 'text-pink-700' },
	{ bg: 'bg-rose-100', text: 'text-rose-700' },
	{ bg: 'bg-orange-100', text: 'text-orange-700' },
	{ bg: 'bg-amber-100', text: 'text-amber-700' },
	{ bg: 'bg-lime-100', text: 'text-lime-700' },
	{ bg: 'bg-emerald-100', text: 'text-emerald-700' },
	{ bg: 'bg-teal-100', text: 'text-teal-700' },
	{ bg: 'bg-cyan-100', text: 'text-cyan-700' },
	{ bg: 'bg-sky-100', text: 'text-sky-700' },
	{ bg: 'bg-indigo-100', text: 'text-indigo-700' },
	{ bg: 'bg-violet-100', text: 'text-violet-700' },
	{ bg: 'bg-fuchsia-100', text: 'text-fuchsia-700' },
] as const;

/**
 * Simple hash function to convert a string to a number
 */
function hashString(str: string): number {
	let hash = 0;
	for (let i = 0; i < str.length; i++) {
		const char = str.charCodeAt(i);
		hash = (hash << 5) - hash + char;
		hash = hash & hash; // Convert to 32bit integer
	}
	return Math.abs(hash);
}

/**
 * Get consistent Tailwind color classes for a muscle name
 * Same muscle name will always get the same color
 *
 * @param muscleName - The name of the muscle
 * @returns Object with background and text color classes
 */
export function getMuscleColor(muscleName: string): {
	bg: string;
	text: string;
	border?: string;
} {
	// Option 5: Clean Rectangle
	return {
		bg: 'bg-indigo-50',
		text: 'text-indigo-600',
		border: '',
	};
}
